import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography } from 'src/components/CustomTypography';

import srcSuggestions from './assets/suggestions.svg';
import srcTrusted from './assets/trusted.svg';
import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
};
const defaultProps = {
  className: '',
};

export const AuthenticationBanner = ({ className }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.centerWrapper}>
        <CustomTypography className={styles.text}>
          AI that knows
          <br />
          what works
        </CustomTypography>

        <img
          className={styles.imgSuggestions}
          src={srcSuggestions}
          alt="Suggestions"
        />
      </div>

      <img
        className={styles.imgTrusted}
        src={srcTrusted}
        alt="Trusted by"
      />
    </div>
  );
};

AuthenticationBanner.displayName = 'AuthenticationBanner';
AuthenticationBanner.propTypes = propTypes;
AuthenticationBanner.defaultProps = defaultProps;
